export const ALL_VALUE = -100;

interface IFilterList {
  value: number;
  label: string;
  checked: boolean;
}

export const buildNewState = (newCheckedFilter: IFilterList[], prevState: IFilterList[]): IFilterList[] => {
  const prevCheckedList = prevState.filter(item => item.checked).map(item => item.value);
  const prevCheckedCount = prevState.filter(item => item.checked).length;
  const checkedList = newCheckedFilter.map(item => item.value);
  const newCheckedCount = checkedList.length;

  const isChecked = newCheckedCount > prevCheckedCount ? true : false;
  let selectedNumber = 0;
  if (isChecked) {
    selectedNumber = checkedList.filter(x => !prevCheckedList.includes(x))[0];
  } else {
    selectedNumber = prevCheckedList.filter(x => !checkedList.includes(x))[0];
  }

  const newState = prevState.map(item => {
    if (isChecked) {
      if (selectedNumber === ALL_VALUE) {
        item.checked = true;
      } else {
        if (item.value === ALL_VALUE && checkedList.length === prevState.length - 1) {
          item.checked = true;
        } else {
          item.checked = checkedList.includes(item.value);
        }
      }
    } else {
      if (selectedNumber === ALL_VALUE) {
        item.checked = false;
      } else {
        if (item.value === ALL_VALUE) {
          item.checked = false;
        } else {
          item.checked = checkedList.includes(item.value);
        }
      }
    }
    return item;
  });

  return newState;
};
